import { MutationTree } from 'vuex';
import { EntraJobsState } from './types';
import entraJobDetailLog, { EntraJobDetailLog, Value } from '@/shared/model/entraJobDetailLog';

export const mutations: MutationTree<EntraJobsState> = {
  setEntraJobDetailLog(state, payload: Value) {
    state.entraJobDetailLog.items = payload.value.map((x) => entraJobDetailLog.parse(x));
    state.entraJobDetailLog.total = payload['@odata.count'] || 0;
    state.entraJobDetailLog.isLoading = false;
  },
  setUpdatingUsersData(state, payload: any) {
    state.updatingUsersData = payload;
  },
  setUpdatingUsers(state, payload: boolean) {
    state.updatingUsers = payload;
  },
  setEntraJobsSearchData(state, payload: any) {
    state.entraJobsSearchData = payload;
  },
};
